import {selector} from './selector';

const PageRegisterTagProcessFormMonriMK = (function ($) {

    function initCardForm() {
        const monri = Monri($(selector.token).val(), {
            locale: 'sr'
        });
        const components = monri.components({clientSecret: $(selector.clientSecret).val()});
        const card = components.create('card');
        card.mount(selector.cardElement);

        const form = document.getElementById('payment_form');
        form.addEventListener('submit', function (event) {
            event.preventDefault();
            $(selector.cardErrors).html('');
            const transactionParams = {
                address: $(selector.address).val(),
                fullName: $(selector.fullName).val(),
                city: $(selector.city).val(),
                phone: $(selector.phone).val(),
                country: $(selector.country).val(),
                email: $(selector.email).val(),
                orderInfo: $(selector.orderNumber).val(),
                currency: $(selector.currency).val(),
                amount: $(selector.amount).val()
            };

            monri.confirmPayment(card, transactionParams).then(function (result) {
                if (result.error) {
                    $(selector.cardErrors).html(result.error.message);
                } else {
                    handlePaymentResult(result.result)
                }
            });

            function handlePaymentResult(paymentResult) {
                if (paymentResult.status === 'approved') {
                    paymentResult.orderNumber = $(selector.orderNumber).val();
                    API.service.payment.confirmTransaction(paymentResult).done(response => {
                        if (response.status === 'success') {
                            window.location.href = response.redirectUrl;
                        } else if (response.status === 'error') {
                            $(selector.cardErrors).html(response.message);
                            setTimeout(function () {
                                window.location.href = response.redirectUrl;
                            }, 2000);
                        }
                    });
                } else {
                    window.location.href = '/payment/cancel';
                }
            }
        });
    }

    function initialize() {
        initCardForm();
    }

    return {
        init: initialize
    }
})(jQuery);

export {PageRegisterTagProcessFormMonriMK};
